// src/pages/customer/Terms.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const sections = [
  {
    title: "1. About Tripura Agro",
    body: "Tripura Agro Industries was established in 2022 with the goal of leveraging supply and demand between farmers and Mandis at the national level. We are a team who understand crops, farmers, commodities and taste. Our focus lies in curating a diverse product portfolio encompassing rice, pulses, spices, wheat, soya, and value-added items. Our commitment is to ensure unparalleled quality and purity, tailored to meet the specific needs of every customer.",
  },
  {
    title: "2. Acceptance of Terms",
    body: "By accessing and using Tripura Agro's website and services, you agree to comply with and be bound by these Terms & Conditions. If you do not agree with any part of these terms, please refrain from using our website.",
  },
  {
    title: "3. Products and Services",
    body: "Tripura Agro provides agricultural products, groceries, food grains, pulses, spices, and related items. All products displayed on the website are subject to availability and may be modified or discontinued without prior notice.",
  },
  {
    title: "4. Account Responsibility",
    body: "Customers are responsible for maintaining the confidentiality of their account information and password. Any activity carried out through your account will be considered your responsibility.",
  },
  {
    title: "5. Pricing and Availability",
    body: "All prices displayed on the website are in Indian Rupees (INR). While we strive to ensure pricing accuracy, Tripura Agro reserves the right to correct pricing errors and update prices without prior notice.",
  },
  {
    title: "6. Order Confirmation",
    body: "Orders placed through our website are subject to acceptance and availability. Tripura Agro reserves the right to refuse or cancel any order for any reason, including product unavailability or pricing inaccuracies.",
  },
  {
    title: "7. Payment Terms",
    body: "We currently support Cash on Delivery (COD) and any other payment methods displayed during checkout. Customers must ensure accurate payment details and timely payment upon delivery.",
  },
  {
    title: "8. Delivery Policy",
    body: "Delivery timelines may vary based on product availability and delivery location. While we strive for timely deliveries, Tripura Agro shall not be held responsible for delays caused by circumstances beyond our control.",
  },
  {
    title: "9. Return and Refund Policy",
    body: "Customers must report damaged, defective, or incorrect products within 24 hours of delivery. Refunds or replacements will be processed after verification. Perishable goods may not be eligible for returns unless found damaged upon delivery.",
  },
  {
    title: "10. Intellectual Property",
    body: "All content on this website, including text, logos, images, graphics, and product information, is the property of Tripura Agro and may not be copied, reproduced, or distributed without prior written permission.",
  },
  {
    title: "11. Limitation of Liability",
    body: "Tripura Agro shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our website, products, or services.",
  },
  {
    title: "12. Governing Law",
    body: "These Terms & Conditions shall be governed by and interpreted in accordance with the laws of India. Any disputes arising from these terms shall be subject to the jurisdiction of the courts of Odisha.",
  },
  {
    title: "13. Changes to Terms",
    body: "Tripura Agro reserves the right to modify or update these Terms & Conditions at any time without prior notice. Continued use of the website after such updates constitutes acceptance of the revised terms.",
  },
];

export default function Terms() {
  return (
    <div style={{ background: "#f7f3e3" }}>
      <Helmet>
        <title>Terms & Conditions | Tripura Agro</title>
        <meta
          name="description"
          content="Tripura Agro Industries was established in 2022 with the goal of leveraging supply and demand between farmers and Mandis at the national level and the final customer, who may be an individual or an institution."
        />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">

        <h1
          className="font-bold uppercase mb-8"
          style={{
            fontSize: "clamp(1.5rem, 3vw, 2rem)",
            color: "#2d3a1e",
            letterSpacing: "0.06em",
          }}
        >
          Terms &amp; Conditions
        </h1>

        <p className="text-sm sm:text-base leading-relaxed mb-10" style={{ color: "#444" }}>
          Please read these terms carefully before using Tripura Agro's website and services.
          By continuing to use our platform, you agree to be bound by the following terms.
        </p>

        <div className="space-y-9">
          {sections.map((s) => (
            <div key={s.title}>
              <h2
                className="font-bold uppercase mb-3"
                style={{ fontSize: "1rem", color: "#2d3a1e", letterSpacing: "0.04em" }}
              >
                {s.title}
              </h2>
              <p className="text-sm sm:text-base leading-relaxed" style={{ color: "#444" }}>
                {s.body}
              </p>
            </div>
          ))}

          {/* Contact section */}
          <div>
            <h2
              className="font-bold uppercase mb-3"
              style={{ fontSize: "1rem", color: "#2d3a1e", letterSpacing: "0.04em" }}
            >
              14. Contact Us
            </h2>
            <p className="text-sm sm:text-base leading-relaxed" style={{ color: "#444" }}>
              If you have any questions about these Terms & Conditions, please contact us at:
            </p>
            <p className="text-sm sm:text-base leading-relaxed mt-2" style={{ color: "#444" }}>
              Tripura Agro Industries OPC Pvt. Ltd.<br />
              Mail Id:{" "}
              <a href="mailto:sandeep@tripuraagro.com" style={{ color: "#4a6e30", fontWeight: 600 }}>
                sandeep@tripuraagro.com
              </a>
              <br />
              Contact No.:{" "}
              <a href="tel:+919778553533" style={{ color: "#4a6e30", fontWeight: 600 }}>
                +91 9778553533
              </a>
              <br />
              1st Floor, Panigrahy Complex, Janata Lane, Digapahandi, Ganjam, Odisha
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}